import { useEffect, useState } from "react";
import FormItem from "./FormItem";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Grid } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import api from "../../api"
import MultiSelectDropdown from "../../shared/MultiSelectDropdown";
import { connect, useDispatch } from "react-redux";
import { 
  updateUserBrandMarket, 
  updateAgencyMarket, 
  updateRegions, 
  updateAgencyCountry 
} from "../../redux/reducers/userReducer";

const MarketSection = ({ user, formoptions, selectedBrand }) => {
  const dispatch = useDispatch();
  const [snackbarState, setSnackbarState] = useState({ open: false });
  const [productGroups, setProductGroups] = useState([]);
  const [isLoadingProductGroups, setIsLoadingProductGroups] = useState(true);
  const { open } = snackbarState;
  
  useEffect(() => {
    const fetchProductGroups = () => {
      setIsLoadingProductGroups(true);
      api.getProductGroups((res) => {
        if (res.status === 200 && res.data) {
          const formattedProductGroups = res.data
            .map((group) => ({
              label: group.name,
              value: group.id
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
          setProductGroups(formattedProductGroups);
        }
        setIsLoadingProductGroups(false);
      });
    };

    fetchProductGroups();
  }, []);
  
  const getMarketData = () => {
    if (user?.company_type === 'brandowners' && selectedBrand) {
      return selectedBrand?.market || {};
    }
    return user?.company?.market || {};
  };

  const getRegionsData = () => {
    if (user?.company_type === 'brandowners' && selectedBrand) {
      return selectedBrand?.regions?.map((r) => { 
        return {value: r.region_id, label: r.region} 
      }) || [];
    }
    return user?.company?.regions?.map((r) => { 
      return {value: r.region_id, label: r.region} 
    }) || [];
  };
  
  const [regions, setRegions] = useState(getRegionsData());
  
  const [selectedProductCategories, setSelectedProductCategories] = useState(() => {
    const marketData = getMarketData();
    if (marketData?.product_categories) {
      return marketData.product_categories.map((c) => { 
        return {label: c.name, value: c.productgroup_id} 
      });
    }
    return [];
  });
  
  const [selectedTargetGroups, setSelectedTargetGroups] = useState(() => {
    const marketData = getMarketData();
    if (marketData?.target_groups) {
      return marketData.target_groups.map((c) => { 
        return {label: c, value: c} 
      });
    }
    return [];
  });

  useEffect(() => {
    const marketData = getMarketData();
    const regionsData = getRegionsData();
    
    setRegions(regionsData);
    
    if (marketData?.product_categories) {
      setSelectedProductCategories(marketData.product_categories.map((c) => ({ 
        label: c.name, 
        value: c.productgroup_id 
      })));
    } else {
      setSelectedProductCategories([]);
    }
    
    if (marketData?.target_groups) {
      setSelectedTargetGroups(marketData.target_groups.map((c) => ({ 
        label: c, 
        value: c 
      })));
    } else {
      setSelectedTargetGroups([]);
    }
  }, [selectedBrand]);

  const getCountryData = () => {
    let cntTmp = [];
    const regionsSource = user?.company_type === 'brandowners' && selectedBrand 
      ? selectedBrand?.regions 
      : user?.company?.regions;
      
    regionsSource?.map((r) => { 
      if(cntTmp.indexOf(r.country) < 0) cntTmp.push(r.country); 
      return null 
    });
    return cntTmp.map((r) => { return {label: r, value: r} });
  };

  const [country, setCountry] = useState(getCountryData());

  useEffect(() => {
    setCountry(getCountryData());
  }, [selectedBrand]);

  const [targetGroups] = useState([
    { value : "Luxury", label : "Luxury" },
    { value : "Mid-Market", label : "Mid-Market" },
    { value : "Discounter", label : "Discounter" },
  ]);

  const handleSaveChanges = () => {
    const formattedRegions = regions.map((region) => ({
      value: region.value, 
      label: region.label,
    }));

    const payload = {
      region_presences    : formattedRegions.map((region) => region.value),
      product_categories  : selectedProductCategories.map((cat) => cat.value),
      target_groups       : selectedTargetGroups.map((group) => group.value),
    };

    if (user?.company_type === 'agencies') {
      handleSaveAgencyMarket(payload);
    } else if (user?.company_type === 'brandowners') {
      if (selectedBrand) {
        handleSaveBrandSpecificMarket(payload);
      } else {
        handleSaveBrandMarket(payload);
      }
    }
  };

  const handleSaveAgencyMarket = (payload) => {
    api.updateAgencyMarket(
      user.company.id, payload, 
      (res) => {
        if (res.status === 200) {
          dispatch(updateRegions(res.data.regions));
          dispatch(updateAgencyMarket(res.data.market));
          openSuccessSnackbar();
        }
      }
    );
  };

  const handleSaveBrandMarket = (payload) => {
    api.updateBrandMarket(
      user.company.id, payload, 
      (res) => {
        if (res.status === 200) {
          dispatch(updateRegions(res.data.regions));
          dispatch(updateUserBrandMarket(res.data.market));
          openSuccessSnackbar();
        }
      }
    );
  };

  const handleSaveBrandSpecificMarket = (payload) => {
    api.updateBrandMarket(
      selectedBrand.id, payload, 
      (res) => {
        if (res.status === 200) {
          dispatch(updateRegions(res.data.regions));
          openSuccessSnackbar();
        }
      }
    );
  };

  const openSuccessSnackbar = () => {
    setSnackbarState({ open: true });
  };

  const handleCloseSnackbar = () => {
    setSnackbarState({ open: false });
  };

  const getRegions = () => {
    return formoptions?.regions?.filter((r) => {
      for(var i in country) { 
        if(country[i].label == r.country) return true 
      }
      return false;
    }).map((r) => { return {value: r.id, label: r.name} })
  }

  if (user?.company_type === 'brandowners' && !selectedBrand) {
    return (
      <div className="text-center py-8">
        <p className="text-neutral-500 dark:text-neutral-400 mb-4">
          Please select a brand profile from the dropdown above to manage market settings.
        </p>
      </div>
    );
  }

  return (
    <>
      <div style={{ marginTop: 26 }} className="w-14"></div>
      
      {user?.company_type === 'brandowners' && selectedBrand && (
        <div className="mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-700">
          <p className="text-sm text-blue-700 dark:text-blue-300">
            Managing market settings for: <strong>{selectedBrand.name}</strong>
          </p>
        </div>
      )}
      
      <div className="space-y-8">
        <FormItem label="Country">
          <MultiSelectDropdown
            options={formoptions?.countries?.map((cnt)=> {return {label: cnt, value: cnt}})}
            onChange={setCountry}
            value={country}
          />
        </FormItem>
        <FormItem label="Activity Regions / Regions of Operation">
          <MultiSelectDropdown
            options={getRegions()}
            onChange={setRegions}
            value={regions}
          />
        </FormItem>
        <FormItem label="Product Categories">
          <MultiSelectDropdown
            options={productGroups}
            value={selectedProductCategories}
            onChange={setSelectedProductCategories}
            disabled={isLoadingProductGroups}
            placeholder={isLoadingProductGroups ? "Loading product groups..." : "Select product categories"}
          />
        </FormItem>

        {/* Requires development of new features */}
        <FormItem label="Target Groups">
          <MultiSelectDropdown
            options={targetGroups}
            value={selectedTargetGroups}
            onChange={setSelectedTargetGroups}
          />
        </FormItem>

        <Grid container direction={"row"} className={"fullWidth"}>
          <div className={"flex-1"}></div>
          <ButtonPrimary onClick={handleSaveChanges}>Save Changes</ButtonPrimary>
        </Grid>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        message="Market Section Saved"
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Market Section Saved Successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = ( state ) => ({
    user    : state.user.user,
    formoptions : state.formoptions.options
});

export default connect( 
    mapStateToProps, 
    { 
        updateUserBrandMarket, 
        updateAgencyMarket, 
        updateRegions, 
        updateAgencyCountry
    } 
)( MarketSection );
